import { render, staticRenderFns } from "./TheMagazineImage.vue?vue&type=template&id=602b9626&scoped=true"
import script from "./TheMagazineImage.vue?vue&type=script&lang=js"
export * from "./TheMagazineImage.vue?vue&type=script&lang=js"
import style0 from "./TheMagazineImage.vue?vue&type=style&index=0&id=602b9626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602b9626",
  null
  
)

export default component.exports